import { Spinner } from '~/components/ui/common/Spinner';

export const ThinkingState = () => {
  return (
    <div className="text-center p-5">
      <h3 style={{ color: 'var(--bq-text-primary)' }}>Thinking...</h3>
      <Spinner size={16} />
    </div>
  );
};
